//–– cookie helpers ––
function setCookie(name,value,days){var d=new Date();d.setTime(d.getTime()+days*864e5);document.cookie=name+"="+value+";expires="+d.toUTCString()+";path=/";}
function getCookie(name){return document.cookie.split('; ').find(r=>r.startsWith(name+"="))?.split('=')[1]||"";}

document.addEventListener('DOMContentLoaded',function(){
  if(!getCookie('ageVerified')){
    var popup=document.getElementById('age-verification-popup');
    popup.style.display='block';
    document.getElementById('age-yes').onclick=function(){
      setCookie('ageVerified','true',365);
      popup.style.display='none';
    };
    document.getElementById('age-no').onclick=function(){
      window.location.href='https://www.google.com';
    };
  }
});

